import $ from "jquery";

window.$ = window.jQuery = $;

$(function () {
    function slickIt() {
        $(".slick-case-studies, .analysis-slide").each(function () {
            let slideNumber = 5;
            if ($(this).attr("data-slide-number")) {
                slideNumber = $(this).attr("data-slide-number");
            }

            $(this).slick({
                arrows: true,
                slidesToScroll: 1,
                rows: 1,
                slidesToShow: 3,
                autoplay: false,
                autoplaySpeed: 3000,
                infinite: true,
                dots: false,
                variableWidth: true,

                responsive: [
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 3,
                            variableWidth: false,
                            arrows: false,
                            dots: true,
                        },
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            variableWidth: false,
                            slidesToShow: 2,
                            arrows: false,
                            dots: true,

                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            variableWidth: false,
                            centerMode: true,
                            centerPadding: '24px',
                            slidesToShow: 1,
                            arrows: false,
                            dots: true,
                        },
                    },
                ],
            });
        });
    }

    slickIt();
});
